import { defineComponent as _defineComponent } from 'vue'
import { ref, toRaw } from "vue";
import GifSettings from "./components/GifSettings.vue";
import VideoToGIFEncoder, { EncoderEvents } from "./lib/encoder";
import GifEncoding from "./components/GifEncoding.vue";
import GifPreview from "./components/GifPreview.vue";
import useEncodeSettings from "./composables/use-encode-settings";
import { Settings, AspectRatios } from "./composables/use-encode-settings";
import GifFooter from "./components/GifFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const progress = ref(0);
const encoding = ref(false);
const image = ref<string>();
const { updateSettings, resetSettings, settings } = useEncodeSettings();

const aspectRatioAsNumber = (aspectRatio: AspectRatios) => {
  const [w = 1, h = 1] = aspectRatio.split(":").map((n) => parseInt(n));

  return w / h;
};

let encoder: VideoToGIFEncoder | undefined;

const back = () => {
  encoder?.cancel();
  image.value = undefined;
};

const reset = () => {
  encoder?.cancel();
  resetSettings();
  image.value = undefined;
};

const encodeVideo = (encodeSettings: Settings) => {
  if (encoding.value) {
    return;
  }

  const { frameRate, videoUrl, startTime, endTime, aspectRatio } = toRaw(encodeSettings);

  if (!videoUrl) {
    return;
  }

  updateSettings(encodeSettings);

  encoding.value = true;

  encoder = new VideoToGIFEncoder(videoUrl, {
    aspectRatio: aspectRatioAsNumber(aspectRatio),
    frameRate,
    startTime,
    endTime,
    dither: true
  });

  encoder.subscribe(EncoderEvents.Progress, (value: number) => {
    progress.value = value;
  });

  encoder.subscribe(EncoderEvents.Cancelled, () => {
    encoding.value = false;
  });

  encoder.subscribe(EncoderEvents.Completed, (bytes: Uint8Array, timeToEncode: number) => {
    encoding.value = false;
    image.value = URL.createObjectURL(new Blob([bytes.buffer], { type: "image/gif" }));

    // eslint-disable-next-line no-console
    console.log(timeToEncode);
  });

  encoder.encode();
};

return { __sfc: true,progress, encoding, image, updateSettings, resetSettings, settings, aspectRatioAsNumber, encoder, back, reset, encodeVideo, GifSettings, GifEncoding, GifPreview, GifFooter }
}

})